'use client';
import Accordion from "./Accordion.js";
export default Accordion;